import { apiV2 } from 'services/iclinic/api';
import { PromiseResponse } from '@types';
import { Patient } from './state/patient';

export const getPatientInfo = (patientId: string): PromiseResponse<Patient> =>
  apiV2.get(`/patients/patient/${patientId}/`);
